import { twClassMerge } from '@healthhub/react-ui';
import { Divider, Typography } from 'antd';

import { USER_PROFILE_DEFAULT_NAME } from '@shared/constants/constants';
import useMobileScreen from '@shared/hooks/useMobileScreen';
import { getDefaultProfilePicDisplay, getProfilePictureS3ImageDisplay } from '@shared/utils/profile';

export interface InformationHeaderContentProps {
  age?: number;
  className?: string;
  displayAge?: string;
  gender?: string;
  hideAge?: boolean;
  hideRelationship?: boolean;
  name: string;
  photo?: string;
  relationship?: string;
}

const { Text } = Typography;

const InformationHeaderContent = ({
  age,
  className,
  displayAge,
  gender,
  hideAge,
  hideRelationship,
  name,
  photo,
  relationship,
}: InformationHeaderContentProps) => {
  const isMobileResponse = useMobileScreen();

  return (
    <div className={twClassMerge('flex flex-row gap-x-4 px-4 py-5 items-center', className)}>
      <img
        alt=""
        className={twClassMerge('size-9px rounded-[12px] object-cover gbomit')}
        onError={(e) => {
          e.currentTarget.src = getDefaultProfilePicDisplay(null, null);
        }}
        src={getProfilePictureS3ImageDisplay(photo ?? '', gender ?? '', age)}
      />
      <div className="flex flex-col">
        <Text
          className={twClassMerge('text-base w-full font-semibold gbmask', {
            'text-ellipsis overflow-hidden mr-3': isMobileResponse,
          })}
        >
          {name || USER_PROFILE_DEFAULT_NAME}
        </Text>

        <Text className="text-sm">
          {!hideAge && !!age && !!displayAge && (
            <Text className="gbmask text-sm font-normal">{displayAge}</Text>
          )}

          {!!relationship && !hideRelationship && (
            <>
              <Divider className="[&_.ant-divider-vertical]: self-center border-l-functional-stone" type="vertical" />
              <Text className="gbmask text-sm font-normal">{relationship}</Text>
            </>
          )}
        </Text>
      </div>
    </div>
  );
};

export default InformationHeaderContent;
